import React, { Suspense, lazy, type ComponentType } from "react";
import ReactDOM from "react-dom/client";

import "./styles/globals.css";

// Path-dispatched bootstrap. The public landing (`/`) and privacy
// (`/privacy`) routes get their own lightweight chunks so a first-time
// visitor never downloads the dashboard surface (assistant runtime, inbox
// shell, radix dialog/sheet/tooltip, MemoryRouter previews). Anything else
// (`/inbox`, `/search`, `?preview=...`, etc.) falls through to the full
// dashboard `App`, which mounts its own ErrorBoundary + Toaster.
function pickEntry(): () => Promise<{ default: ComponentType }> {
  const path = typeof window === "undefined" ? "/" : window.location.pathname;
  const search =
    typeof window === "undefined"
      ? new URLSearchParams()
      : new URLSearchParams(window.location.search);
  if (search.has("preview")) {
    return () => import("./App").then((m) => ({ default: m.App }));
  }
  if (path === "/" || path === "") {
    return () =>
      import("./landing-entry").then((m) => ({ default: m.LandingApp }));
  }
  if (path === "/privacy" || path === "/privacy/") {
    return () =>
      import("./privacy-entry").then((m) => ({ default: m.PrivacyApp }));
  }
  return () => import("./App").then((m) => ({ default: m.App }));
}

const Entry = lazy(pickEntry());

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("missing #root element");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <Entry />
    </Suspense>
  </React.StrictMode>,
);
